import React, { Component } from "react";
import { Label } from "reactstrap";

export default class FormTitle extends Component {
  render() {
    const { title } = this.props;
    return <div>{title && <Label className=" h6 my-3">{title}</Label>}</div>;
  }
}
